<div class="container-fluid">
  <div class="card" *ngIf="privacy">
    <div class="title">
      <div>개인정보 처리 방침</div>
    </div>
    <div class="card-body top">
      <div class="content">{{ privacy }}</div>
    </div>
  </div>
</div>
